import { VCard } from 'vuetify/lib/components/VCard';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VResponsive } from 'vuetify/lib/components/VResponsive';

var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(VCard, {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "tile": "",
      "elevation": "0"
    }
  }, [_c(VOverlay, {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.state !== _vm.State.OPEN,
      expression: "state !== State.OPEN"
    }],
    staticClass: "text-center",
    attrs: {
      "absolute": "",
      "color": "dark",
      "opacity": "0.1"
    }
  }, [_vm.state === _vm.State.LOADING ? [_c('p', {
    staticClass: "my-4"
  }, [_vm._v("Kamerakép betöltése")]), _c(VProgressLinear, {
    attrs: {
      "stream": "",
      "buffer-value": "0",
      "rounded": "",
      "height": "5"
    }
  })] : _vm.state === _vm.State.ERROR ? [_c(VIcon, {
    attrs: {
      "size": "96",
      "color": "primary"
    }
  }, [_vm._v("mdi-alert-rhombus-outline")]), _c('p', {
    staticClass: "my-4",
    domProps: {
      "innerHTML": _vm._s(_vm.errorMessage)
    }
  }), _vm.retryTimeout ? _c(VProgressLinear, {
    attrs: {
      "rounded": "",
      "height": "5"
    },
    model: {
      value: _vm.retryIntervalProgress,
      callback: function ($$v) {
        _vm.retryIntervalProgress = $$v;
      },
      expression: "retryIntervalProgress"
    }
  }) : _vm._e()] : _vm._e()], 2), _c(VResponsive, {
    staticClass: "d-flex justify-center align-center",
    attrs: {
      "aspect-ratio": 16 / 9
    }
  }, [_c(VExpandTransition, [_c('canvas', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.state === _vm.State.OPEN,
      expression: "state === State.OPEN"
    }],
    ref: "canvas",
    staticStyle: {
      "width": "100%",
      "display": "block"
    }
  })])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }